import React from "react";

const Pagination = (props) => {

    const CurrentPage = props.CurrentPage;
    const setCurrentPage = props.setCurrentPage;
    const SearchResult = props.SearchResult;
    const DataPerPage = props.DataPerPage;


    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
    }

    const totalPages = Math.ceil(SearchResult.length / DataPerPage);

    return (
        <>
            <nav aria-label="Page navigation example">
                <ul className="pagination justify-content-end">
                    <li className={`page-item ${CurrentPage === 1 ? 'disabled' : ''}`}>
                        <a className="page-link" href="##" onClick={() => handlePageChange(CurrentPage - 1)}>
                            Previous
                        </a>
                    </li>
                    {[...Array(totalPages)].map((_, index) => (
                        <li key={index + 1} className={`page-item ${CurrentPage === index + 1 ? 'active' : ''}`}>
                            <a className="page-link" href="##" onClick={() => handlePageChange(index + 1)}>
                                {index + 1}
                            </a>
                        </li>
                    ))}
                    <li className={`page-item ${CurrentPage === totalPages ? 'disabled' : ''}`}>
                        <a className="page-link" href="##" onClick={() => handlePageChange(CurrentPage + 1)}>
                            Next
                        </a>
                    </li>
                </ul>
            </nav>

        </>
    );
};

export default Pagination;
